import { render, staticRenderFns } from "./SkillCategories.vue?vue&type=template&id=808b98fe&scoped=true"
import script from "./SkillCategories.vue?vue&type=script&lang=js"
export * from "./SkillCategories.vue?vue&type=script&lang=js"
import style0 from "./SkillCategories.vue?vue&type=style&index=0&id=808b98fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808b98fe",
  null
  
)

export default component.exports